<template>
    <div class="container">
        <div class="login">
                <h2>欢迎注册跳转代理</h2>
                <p>(注册就送免费套餐体验)</p>
                <Form ref="formInline" :model="formInline" :rules="ruleValidate" >
                    <FormItem  prop="mobile" class="input-phone">
                        <Input type="text" v-model.number="formInline.mobile" placeholder="手机号" clearable />
                        <span class="rg-icon"></span>
                    </FormItem>
                    <!-- <FormItem  prop="username" class="input-user">
                        <Input type="text"  v-model="formInline.username" placeholder="用户名长度为6-18,以字母开头" clearable />
                        <span class="rg-icon"></span>
                    </FormItem> -->
                    <FormItem  prop="password" class="input-pwd">
                        <Input type="password" v-model="formInline.password" placeholder="密码"  clearable/>
                        <span class="rg-icon"></span>
                    </FormItem>
                    <!-- <FormItem  prop="rpassword" class="input-repeat">
                        <Input type="password"  v-model="formInline.rpassword" placeholder="请再输入密码" clearable />
                        <span class="rg-icon"></span>
                    </FormItem> -->
                    <!-- <FormItem  prop="mobile" class="input-phone">
                        <Input type="text" v-model.number="formInline.mobile" placeholder="手机号可用作登录或重置密码" clearable />
                        <span class="rg-icon"></span>
                    </FormItem> -->
                     <FormItem prop="code" class="input-code">
                         <Row>
                            <Input type="text"  v-model.number="formInline.code" class="phonenum" placeholder="请输入您的验证码"  />
                            <span class="rg-icon"></span>
                            <input type="hidden" id="ticket" name="ticket" value="">
                            <div id="TCaptcha" style="display:none;"></div>
                            <i class="VerificationCode" v-if="showcode" @click="getverification">获取验证码</i>
                            <i class="VerificationCode" v-if="!showcode">{{count}}s</i>
                        </Row>
                    </FormItem>
                    <FormItem prop="code" class="input-code" style="display:none;">
                         <Row>
                           <drag-verify
                            :width="dragVerify.width"
                            :height="dragVerify.height"
                            :text="dragVerify.text"
                            :success-text="dragVerify.successText"
                            :background="dragVerify.background"
                            :progress-bar-bg="dragVerify.progressBarBg"
                            :completed-bg="dragVerify.completedBg"
                            :text-size="dragVerify.textSize"
                            :success-icon="dragVerify.successIcon"
                            :circle="dragVerify.isCircle"
                            ref="Verify">
                            </drag-verify>
                        </Row>
                    </FormItem>
                    <FormItem>
                        <Checkbox v-model="protocol"><a href="javascript:;" @click="instance('info')"><b>同意</b>《跳转代理软件协议》</a></Checkbox>
                        <Button type="primary" @click="handleSubmit('formInline')" class="sub" ref="Register">注册</Button>
                        <div class="tc">
                            <span>已有账号？</span>
                            <router-link to="/Login">立即登录</router-link>
                        </div>
                    </FormItem>
            </Form>
        </div>
         <Modal
            v-model="modalStatus"
            title="提示"
            @on-ok="ok"
            @on-cancel="cancel">
            <p class="tc ft-20">{{modalStatusText}}</p>
            <!-- <p class="tc ft-20">是否马上前往登录</p> -->
        </Modal>
    </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js"
import dragVerify from 'vue-drag-verify'
import Cookies from 'js-cookie'
export default {
    components: {
      dragVerify
    },
    data () {
        var _this = this
        var  validateuser = function(rule, value, callback){
            if(!value){
                return callback(new Error("请输入用户名"));
            }else{
                callback();
            }
        }
        var  validatenick = function(rule, value, callback){
            if(!value){
                return callback(new Error("请输入用户名称"));
            }else if(!/^[\u4e00-\u9fa5]+$/.test(value)){
                return callback(new Error("请正确输入用户名称"))
            }else{
                callback();
            }
        }
        var validatePass = function(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        }
        var validatePassCheck = function(rule, value, callback){
            if (value === '') {
                return callback(new Error('请再次输入密码'));
            } else if (value !== _this.formInline.password) {
                return callback(new Error('两次密码不一致'));
            } else {
                callback();
            }
        }
        var validateMoblie = (rule, value, callback) => {
            if(typeof value !== "number" || value.toString().length != 11){
                callback('请输入正确的手机格式')
            }else {
                callback();
            }
        }
         var validateCode = (rule, value, callback) => {
            if(typeof value !== "number"){
                callback('请输入正确的验证码')
            }else {
                callback();
            }
        }
        return {
            formInline: {
                username: '',
                password: '',
                rpassword: '',
                code: '',
                mobile: '',
                dev: '',
            },
            count: '',
            showcode: true,
            timer: null,
            ruleValidate:{
                username    : [{required: true, message: '请输入您的用户名', trigger: 'blur'}],
                password    : [{validator: validatePass, trigger: 'blur'},{min:6,message:'请输入最少6位'}],
                rpassword   : [{validator: validatePassCheck, trigger: 'blur'},{min:6,message:'请输入最少6位'}],
                mobile      : [{validator: validateMoblie, trigger: 'blur'}],
                code        : [{validator: validateCode, trigger: 'blur'}]
            },
            protocol: true,
            modalStatus: false,
            modalStatusText: '',
            channel1: 'huashengdaili',
            channel2: 'tiaozhuan',
            dragVerify:{
              width: 322,
              height: 38,
              text: '请拖拽验证',
              successText: '验证成功',
              background: '#ccc',
              progressBarBg: '#79d8bb',
              completedBg : '#2bd3a0',
              isCircle: false,
              handlerBg : '',
              textSize : '16px'
            },
            dragVerifyStatus: false
        }
    },
    methods: {
        fixdragVerify () {
          var userAgents = navigator.userAgent
          var a = userAgents.indexOf("Android") >= 0 ? true : false
          var b = userAgents.indexOf("iPhone") >= 0 ? true : false
            if(a || b){
              // 移动端去除滑动验证组件
               document.querySelector(".drag_verify").style.display = 'none'
               this.dragVerifyStatus = true
            }else{
               // 修复dragVerify组件宽高问题 - -
              var dom = document.querySelector('.dv_handler_bg')
              dom.style.width = '38px'
              dom.style.height = '38px'
              this.dragVerifyStatus = false
          }
        },
        ok () {
            if(this.modalStatusText !== '注册成功'){
                return
            }
            this.$router.push("/Login")
        },
        cancel () {
            this.$Message.info('取消');
        },
        handleSubmit(name) {
            this.$Loading.start()
             // dragVerifyStatus 检测设备类型 移动端 为true 不进行此校验
            // if(!this.dragVerifyStatus) {
            //   if(!this.$refs.Verify.isPassing){
            //     this.$Message.error("您没有通过验证")
            //     this.$Loading.error()
            //     return
            //   }
            // }
            let arr = []
            if(!this.protocol){
                this.$Message.error("您未同意跳转代理软件协议")
                this.$Loading.error()
                return
            }
            for(var key in this.formInline){
                // if(key == "code" || key == "mobile"){
                //     continue
                // }else{
                //     arr.push(this.formInline[key])
                // }
                arr.push(this.formInline[key])
            }
            arr = arr.sort()
            // if(arr.length > 0) {
            //     for(let i =0;i<arr.length;i++){
            //         if(arr[i] == ""){
            //             this.$Message.error("您的注册信息不完整")
            //             this.$Loading.error()
            //             return
            //         }else if(this.formInline.password !== this.formInline.rpassword){
            //             this.$Message.error("两次密码不一致")
            //             this.$Loading.error()
            //             return
            //         }
            //     }
            // }

            doPost(
                {action: 'register', username:this.formInline.username, password: this.formInline.password, dev:'pc', mobile:this.formInline.mobile, code: this.formInline.code, channel: this.channel2, domain_keyword: `${Cookies.get('domain')}${Cookies.get('keyword')}`},
                (data) => {
                    // this.$Message.success(data.detail)
                    if(data){
                         if(!data.status){
                            if(data.detail){
                                this.modalStatus = true
                                this.modalStatusText = data.detail
                            }else{
                                this.modalStatusText = '网络连接超时'
                            }
                        }else{
                          this.modalStatus = true
                          this.modalStatusText = data.detail
                        }
                      this.$Loading.finish()
                    }
                }
            )
            // this.$refs[name].validate((valid) => {
            //     if (valid) {
            //         this.$Message.success('Success!');
            //     } else {
            //         this.$Message.error('Fail!');
            //     }
            // })
        },
        getverification () {
           // 拉起腾讯验证码服务
            let mobile = this.formInline.mobile;
            let _this = this;
            var capOption = {
                    callback: cbfn,
                    showHeader: true,
                    type: 'popup',
                    firstvrytype: 2
            };
            capInit(document.getElementById("TCaptcha"), capOption);
            //  验证成功发验证码
            function cbfn(retJson) {
              console.log(retJson)
               if (retJson.ret == 0) {
                  // 与后台验证
                  let sendTicket = retJson.ticket
                  doPost(
                    {
                      action: 'check_ticket',
                      ticket: retJson.ticket
                    },
                    (data) => {
                      doPost(
                      {action: 'send', phone:mobile, tag: "4", ticket: sendTicket},
                      (data) => {
                          console.log(data)
                          if(!data.status) {
                            _this.$Message.success(data.detail);
                            console.log(_this)
                            _this.getCode();
                          }else{
                            _this.$Message.error(data.detail);
                          }
                      }
                    )
                    }
                  )
               }
            }
        },
        getCode () {
            const TIME_COUNT = 60
            if(!this.timer){
                this.count = TIME_COUNT
                this.showcode = false
                this.timer = window.setInterval( ()=> {
                    if(this.count > 0 && this.count <= 60) {
                        this.count --
                    } else{
                        this.showcode = true
                        clearInterval(this.timer)
                        this.timer = null
                    }
                },1000)
            }
        },
        verificationpwd () {
            if(this.formInline.mobile == " "){
                console.log('222')
                this.$Notice.open({
                    title: '错误提示',
                    desc: '检测到您并未输入手机号',
                    duration: 0
                })
            }
        },
        TestingEquipment () {
            var system = {
                pc: false,
                iPhone: false,
                Android: false
            }
            system.pc = window.navigator.userAgent.indexOf("Windows") > 0 ? true : false
            system.iPhone = window.navigator.userAgent.indexOf("Android") > 0 ? true : false
            system.Android = window.navigator.userAgent.indexOf("iPhone") > 0 ? true : false
            for(var key in system){
                if(system[key]){
                    this.formInline.dev = key
                }
            }
        },
        instance (type) {
            const title = '跳转代理软件使用协议';
            const content = `<p>本注册条款是您与跳转代理相关事宜所订立的契约，请您仔细阅读本注册条款，您点击“同意并继续”后，本条款之效力如同用户亲自签字、盖章的书面条款一样，对用户具有法律约束力。</p>

                            <p> <b style="color:red;font-size:18px;">第1条 用户注册 </b><p>
                            <p> 1.1、用户注册是指用户登录跳转代理，按要求填写相关信息并确认同意本服务协议的过程。</p>
                            <p> 1.2、用户承诺并保证自己是具有完全民事行为能力和完全民事权利能力的自然人、法人、实体和组织。<p>
                            <p> 1.3、本产品提供试用测试，用户购买前应充分测试试用体验，一经出售，概不退款。 </p>

                           <p> <b style="color:red;font-size:18px;">第2条 会员身份确认</b> <p>
                           <p>2.1、用户注册成功后将得到一个用户名和密码，用户凭用户名和密码享受跳转代理向其会员用户提供的商品和服务。<p>
                           <p>2.2、用户将对用户名和密码安全负全部责任，并且用户对以其用户名进行的所有活动和事件负全责。用户有权根据跳转代理规定的程序修改密码。<p>
                           <p>2.3、用户若发现任何非法使用用户帐号或存在安全漏洞的情况，请立即通告跳转代理。<p>

                            <p>
                            <b style="color:red;font-size:18px;">第3条 用户依法言行义务 </b><br>
                            本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：
                            用户保证其使用跳转代理服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用跳转代理提供的服务进行存储、发布、传播如下信息和内容：违反国家法律法规政策的任何内容（信息）；违反国家规定的政治宣传和 /或新闻信息；涉及国家秘密和 /或安全的信息；封建迷信和 /或淫秽、色情、下流的信息或教唆犯罪的信息;博彩有奖、赌博游戏;违反国家民族和宗教政策的信息；防碍互联网运行安全的信息；侵害他人合法权益的信息和 /或其他有损于社会秩序、社会治安、公共道德的信息或内容。用户同时承诺不得为他人发布上述不符合国家规定和 /或本服务条款约定的信息内容提供任何便利，包括但不限于设置 URL、BANNER 链接等。用户承认跳转代理有权在用户违反上述时有权终止向用户提供服务并不予退还任何款项，因用户上述行为给跳转代理成损失的，用户应予赔偿。用户应不时关注并遵守本站不时公布或修改的各类合法规则规定。
                            本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。
                            若用户未遵守以上规定的，本站有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。
                            </p>
                            <p>
                            <b style="color:red;font-size:18px;">第4条 协议更新及用户关注义务 </b><br>
                            根据国家法律法规变化及网站运营需要，跳转代理有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登录查阅最新协议； 用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受网站依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。跳转代理建议您在使用本站之前阅读本协议及本站的公告。 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
                            </p>
                            <p>
                            <b style="color:red;font-size:18px;">第5条 法律管辖和适用</b> <br>
                            本条款的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。 如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。 如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。
                            </p>
                            <p>
                            <b style="color:red;font-size:18px;">第6条 不可抗力</b></br>
                        　　 <span>6.1、因不可抗力或者其他意外事件，使得本条款履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。<span><br>
                        　　 6.2、不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。<br>
                        　　 6.3、用户同意鉴于互联网的特殊性，黑客攻击、互联网连通中断或者系统故障等属于不可抗力，由此给用户或者第三方造成的损失不应由跳转代理承担<br>
                            跳转代理对本协议保留一切解释权利。
                            </p>`;
            switch (type) {
                case 'info':
                    this.$Modal.info({
                        title: title,
                        content: content,
                        width: 900
                    });
                    break;
                case 'success':
                    this.$Modal.success({
                        title: title,
                        content: content
                    });
                    break;
                case 'warning':
                    this.$Modal.warning({
                        title: title,
                        content: content
                    });
                    break;
                case 'error':
                    this.$Modal.error({
                        title: title,
                        content: content
                    });
                    break;
            }
        }

    },
    mounted () {
        this.TestingEquipment()
        this.fixdragVerify()
        doPost({action: 'verification_jsurl'},(data) => {
          let url = data.url;
          let script = document.createElement('script');
          script.id = 'fsq';
          script.src = url
          document.body.appendChild(script);
        })
    }
}
</script>

<style lang="stylus" scoped>
    .container
        width 100%
        // height 100%
        // position fixed
        padding 111px 0px 151px 0px
        background #f0f0f0
        // background-image url("~@/assets/img/login_img/0.0bg.png") !important
        &:after
            content ''
            display block
            height 1px
            clear both
    .login
        margin 0 auto
        width 1000px
        height 595px
        // margin 140px auto
        background #fff
        border-radius 8px
    .login h2
        text-align center
        width 190px
        display block
        margin 0 auto
        font-size 22px
        padding 28px 0px
        padding-bottom 10px
    .login p
        font-size 14px
        text-align center
        padding-bottom 20px
        color #29d3a0
    .phonenum
        display inline-block
        width 70%
    .getnum
        width 28%
        height .86rem
        z-index 99
    >>>.ivu-input
        height 40px
        width 322px
        position relative
        padding-left 50px
    >>> .ivu-btn-primary
        border-color #2dd39f
    .rg-icon
        position absolute
        left 15px
        top 10px
        background-repeat no-repeat
        background-size 80% 70%
        background-position center
        width 22px
        height 22px
    .VerificationCode
        position absolute
        right 15px
        top 5px
        color #999999
        &:before
            content ''
            display block
            position absolute
            left -10px
            top 10px
            width 1px
            height 12px
            background #999999
        &:hover
            color #2bd3a0
    .input-user span
        background-image url("~@/assets/img/register_img/regsiter_icon_user.png")
    .input-pwd span
        background-image url("~@/assets/img/register_img/regsiter_icon_password.png")
    .input-repeat span
        background-image url("~@/assets/img/register_img/regsiter_icon_password.png")
    .input-phone span
        background-image url("~@/assets/img/register_img/regsiter_icon_phone.png")
    .input-code span
        background-image url("~@/assets/img/register_img/regsiter_icon_verificationcode.png")
    .sub
        width 100%
        height .86rem
        font-size .35rem
        background #2BD3A0
    >>> .ivu-form
        width 322px
        margin 0 auto
    @media screen and (max-width: 1025px)
        .container
            height auto
            position fixed
            padding 0px
        .login
            width 100%
            margin auto
    @media screen and (max-width: 456px)
        .container
            height auto
            padding 0px
        .login
            border-radius 0px
    @media screen and (max-width: 320px)
        >>>.ivu-input
            width 320px
</style>



// WEBPACK FOOTER //
// src/pages/Auth/Register.vue